// These are the required environment variables, we need to throw an error if they are not set
if (
    !Object.prototype.hasOwnProperty.call(import.meta.env, 'VITE_API_DOMAIN') ||
    !Object.prototype.hasOwnProperty.call(import.meta.env, 'VITE_API_PATH') ||
    !Object.prototype.hasOwnProperty.call(import.meta.env, 'VITE_WEBPAY_DOMAIN') ||
    !Object.prototype.hasOwnProperty.call(import.meta.env, 'VITE_DJANGO_ADMIN_PATH') ||
    !Object.prototype.hasOwnProperty.call(import.meta.env, 'VITE_SOCKETS_DOMAIN') ||
    !Object.prototype.hasOwnProperty.call(import.meta.env, 'VITE_MAPBOX_ACCESS_TOKEN')
) {
    console.warn(
        `ADD FOLOWING ENVIRONMENT VARIABLES TO .env FILE:
            - VITE_API_DOMAIN
            - VITE_API_PATH
            - VITE_WEBPAY_DOMAIN
            - VITE_DJANGO_ADMIN_PATH
            - VITE_SOCKETS_DOMAIN
            - VITE_MAPBOX_ACCESS_TOKEN
        `
    );
    throw new Error('Missing required environment variable');
}

const ensureTrailingSlash = (value: string): string => (value.endsWith('/') ? value : `${value}/`);

// These are the optional environment variables, we need set default values if they are not set
const optionalEnvVars = {
    LOGROCKET_APP_ID: import.meta.env.VITE_LOGROCKET_APP_ID || '',
    PACKAGE_VERSION: import.meta.env.VITE_NPM_PACKAGE_VERSION || '0.0.0',
    MINUTES_TO_UPDATE_REPORTS: Number(import.meta.env.VITE_MINUTES_TO_UPDATE_REPORTS) || 10,
    WORKOS_ORG_ID: import.meta.env.VITE_WORKOS_ORG_ID || '',
    CLIENT_ID: import.meta.env.VITE_CLIENT_ID || 'airgarage',
    MAPBOX_STYLE: import.meta.env.VITE_MAPBOX_STYLE || '',
    POSTHOG_KEY: import.meta.env.VITE_POSTHOG_KEY || '',
    POSTHOG_HOST: import.meta.env.VITE_POSTHOG_HOST || '',
    IS_STAGING: import.meta.env.VITE_IS_STAGING === 'true',
    PRODUCTION_DASHBOARD_URL: import.meta.env.VITE_PRODUCTION_DASHBOARD_URL || 'https://dashboard.airgarage.com',
};

const env = {
    API_DOMAIN: ensureTrailingSlash(import.meta.env.VITE_API_DOMAIN as string),
    API_PATH: import.meta.env.VITE_API_PATH as string,
    WEBPAY_DOMAIN: import.meta.env.VITE_WEBPAY_DOMAIN as string,
    DJANGO_ADMIN_PATH: import.meta.env.VITE_DJANGO_ADMIN_PATH as string,
    SOCKETS_DOMAIN: import.meta.env.VITE_SOCKETS_DOMAIN as string,
    MAPBOX_TOKEN: import.meta.env.VITE_MAPBOX_ACCESS_TOKEN as string,
    NODE_ENV: import.meta.env.NODE_ENV,
    ...optionalEnvVars,
};

export default env;
